"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    fetchChatStream: ()=>fetchChatStream,
    submitChatMessages: ()=>submitChatMessages
});
const analytics_js_namespaceObject = require("./analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const external_chatTypes_js_namespaceObject = require("./chatTypes.js");
const pennyBroadcast_js_namespaceObject = require("./utils/pennyBroadcast.js");
var pennyBroadcast_js_default = /*#__PURE__*/ __webpack_require__.n(pennyBroadcast_js_namespaceObject);
const updatePennyDebugger_js_namespaceObject = require("./utils/updatePennyDebugger.js");
const browserStorage_js_namespaceObject = require("./utils/browserStorage.js");
const external_localMessagsCache_js_namespaceObject = require("./localMessagsCache.js");
const CHAT_URL = 'https://qaa.priceline.com/genai-svc/genai/chat/st/travelChat';
const JSON_START_DELIMITER = 'jsonstart';
const JSON_END_DELIMITER = 'jsonend';
const CHUNK_DELIMITER = '\r\r\n';
const fetchChatStream = async ({ submitChatMessagesPayload, url, headers, setStreamingText, handleJSON })=>{
    const pennysid = browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.getItem('pennysid') ?? '';
    const transformedSubmitChatMessagesPayload = {
        ...submitChatMessagesPayload,
        pennysid,
        prompts: [
            ...external_localMessagsCache_js_namespaceObject.localCache.getAssistantRefPrompts(),
            ...submitChatMessagesPayload.prompts
        ]
    };
    try {
        let blob;
        const compressionEnabled = 'CompressionStream' in self;
        if (compressionEnabled) {
            const stream = new Blob([
                JSON.stringify(transformedSubmitChatMessagesPayload)
            ], {
                type: 'application/json'
            }).stream();
            const compressedReadableStream = stream.pipeThrough(new CompressionStream('gzip'));
            const compressedResponse = await new Response(compressedReadableStream);
            blob = await compressedResponse.blob();
        }
        const abortController = new AbortController();
        const timeoutId = setTimeout(()=>{
            abortController.abort();
        }, 30000);
        const res = await fetch(url || CHAT_URL, {
            method: 'POST',
            body: compressionEnabled ? blob : JSON.stringify(transformedSubmitChatMessagesPayload),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                ...headers,
                'Content-Encoding': compressionEnabled ? 'gzip' : 'identity'
            },
            signal: abortController.signal
        });
        const timestamp = Date.now();
        if (submitChatMessagesPayload?.includeSpeech) pennyBroadcast_js_default()({
            type: pennyBroadcast_js_namespaceObject.BroadcastType.NEW_MESSAGE_REQUEST_INITIATED,
            messageId: timestamp,
            sender: 'submitChatMessages.fetchChatStream'
        });
        clearTimeout(timeoutId);
        if (200 !== res.status) throw Error(`${res.status}: ${res.statusText}`);
        const pennysidHeader = res.headers.get('Pennysid');
        if (pennysidHeader) browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.setItem('pennysid', pennysidHeader);
        if (!res.body || !res.body.getReader) return {
            isOk: false,
            errorCode: 'NOT_SUPPORTED',
            errorMessage: 'ReadableStream not supported'
        };
        {
            const reader = res.body.getReader();
            let hasJson = false;
            let finalJson = '';
            let timer;
            while(true)try {
                const result = await reader.read();
                if (result?.done) {
                    if (timer) clearTimeout(timer);
                    setStreamingText('STREAMING_ENDED');
                    return {
                        isOk: true
                    };
                }
                if (result?.value) {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(()=>{
                        abortController.abort();
                    }, 20000);
                    const resultValue = result.value?.filter((x)=>0 !== x);
                    const response = new Response(resultValue);
                    const textRes = await response.text();
                    const textArray = textRes.split(CHUNK_DELIMITER);
                    while(textArray.length > 0){
                        const text = textArray.shift();
                        if (text === JSON_START_DELIMITER) hasJson = true;
                        else if (text === JSON_END_DELIMITER) {
                            hasJson = false;
                            handleJSON(finalJson);
                            finalJson = '';
                        } else if (hasJson) finalJson += text;
                        else {
                            setStreamingText(text);
                            if (submitChatMessagesPayload?.includeSpeech) pennyBroadcast_js_default()({
                                type: pennyBroadcast_js_namespaceObject.BroadcastType.ADD_TEXT_TO_SPEECH_QUEUE,
                                data: text.replace(/\0/g, ''),
                                messageId: timestamp,
                                sender: 'submitChatMessages.fetchChatStream'
                            });
                        }
                    }
                }
            } catch (err) {
                return {
                    isOk: false,
                    errorCode: 'READER_READ_ERROR',
                    errorMessage: err?.message
                };
            }
        }
    } catch (err) {
        setStreamingText('STREAMING_ENDED');
        return {
            isOk: false,
            errorCode: 'ERROR',
            errorMessage: err?.message
        };
    }
};
const submitChatMessages = async ({ chatMessages, handleMarkerResponse, markerComponents, requestOptions: { url = '', headers = {} }, setChatMessages: setChatMessages, setErrorMessage, setIsDisablingInputValue, setLoadingStatus, setLoadingStatusMessage, setOpenErrorComponent, setStreamingText, submitChatMessagesPayload })=>{
    setLoadingStatus(true);
    setErrorMessage?.('');
    const fullTexts = [];
    const JSONResponses = [];
    const statusMessages = [];
    let containInlineMetadata = false;
    let delayFinalResponseText = false;
    analytics_js_default().log({
        message: 'Submit Chat Messages started'
    });
    const result = await fetchChatStream({
        submitChatMessagesPayload,
        url,
        headers,
        handleJSON: (jsonstring)=>{
            const parsedJson = JSON.parse(jsonstring);
            if (!containInlineMetadata && 'INLINE_METADATA_MARKER' === parsedJson.displayComponentName) containInlineMetadata = true;
            if (!delayFinalResponseText && 'HOTEL_CARDS_MARKER' === parsedJson.displayComponentName) delayFinalResponseText = true;
            if (setLoadingStatusMessage && 'LOADING_STATUS_MESSAGE_MARKER' === parsedJson.displayComponentName) {
                statusMessages.push(parsedJson.componentProps?.statusMessage);
                setLoadingStatusMessage(statusMessages);
            } else JSONResponses.push(parsedJson);
        },
        setStreamingText: (text)=>{
            if ('STREAMING_ENDED' !== text) {
                fullTexts.push(text);
                const fullText = fullTexts.join('');
                setStreamingText?.(fullText);
            } else setStreamingText?.('');
        }
    });
    if (result?.isOk && 0 !== fullTexts.length) {
        const date = new Date();
        const chatMsgs = [];
        const finalTexts = fullTexts.join('').trim();
        if (finalTexts.toLowerCase().startsWith('system error')) setIsDisablingInputValue?.(true);
        if (finalTexts.length) {
            const promptMsg = {
                role: 'assistant',
                content: finalTexts
            };
            if (!containInlineMetadata && !delayFinalResponseText) {
                const chatMsg = {
                    ...promptMsg,
                    date,
                    vote: external_chatTypes_js_namespaceObject.VoteType.NONE
                };
                chatMsgs.push(chatMsg);
            }
        }
        if (JSONResponses.length > 0) JSONResponses.forEach((jsonResponse)=>{
            const { displayComponentName, content: textContent, componentProps, assistantPromptMessage } = jsonResponse;
            if ('function' == typeof handleMarkerResponse && markerComponents?.[displayComponentName]) {
                const { role = 'assistant', content = displayComponentName, messageContent = '', markerComponentProps = {} } = handleMarkerResponse(void 0, displayComponentName, textContent, componentProps, chatMessages);
                const date = new Date();
                if (messageContent || content && content !== displayComponentName) {
                    const chatMessage = {
                        role,
                        content: messageContent || content,
                        date,
                        vote: external_chatTypes_js_namespaceObject.VoteType.NONE
                    };
                    chatMsgs.push(chatMessage);
                }
                const chatMessage = {
                    role,
                    content: '',
                    displayComponentName,
                    markerComponentProps: {
                        ...componentProps,
                        ...markerComponentProps
                    },
                    date,
                    vote: external_chatTypes_js_namespaceObject.VoteType.NONE
                };
                chatMsgs.push(chatMessage);
            } else {
                const date = new Date();
                const componentMessage = {
                    role: '',
                    content: '',
                    displayComponentName,
                    markerComponentProps: {
                        ...componentProps
                    },
                    date,
                    vote: external_chatTypes_js_namespaceObject.VoteType.NONE
                };
                chatMsgs.push(componentMessage);
                const shouldDisplayDelayFinalText = delayFinalResponseText && finalTexts.length > 0 && !containInlineMetadata;
                const shouldDisplayMarkerTextContent = textContent && textContent !== displayComponentName;
                if (shouldDisplayMarkerTextContent || shouldDisplayDelayFinalText) {
                    const chatMessage = {
                        role: 'assistant',
                        content: '',
                        date,
                        vote: external_chatTypes_js_namespaceObject.VoteType.NONE
                    };
                    if (shouldDisplayDelayFinalText) {
                        delayFinalResponseText = false;
                        chatMessage.content = finalTexts;
                        chatMsgs.push(chatMessage);
                    }
                    if (shouldDisplayMarkerTextContent) {
                        chatMessage.content = textContent;
                        chatMsgs.push(chatMessage);
                    }
                }
            }
            if (assistantPromptMessage) external_localMessagsCache_js_namespaceObject.localCache.setAssistantRefPrompts(assistantPromptMessage);
        });
        (0, updatePennyDebugger_js_namespaceObject.updatePennyDebugger)(submitChatMessagesPayload, [
            ...chatMessages,
            ...chatMsgs
        ], headers);
        const messagesWithNoStructuredData = chatMessages.filter((msg)=>'STRUCTURED_DATA' !== msg.displayComponentName);
        setChatMessages([
            ...messagesWithNoStructuredData,
            ...chatMsgs
        ]);
        setLoadingStatus(false);
        setLoadingStatusMessage([]);
    } else if (!result?.isOk) {
        if ('function' == typeof handleMarkerResponse) handleMarkerResponse(result, '');
        analytics_js_default().log({
            message: 'Failed to submit',
            ...result
        });
        setErrorMessage?.(result.errorMessage ?? 'Network error! Please check your network connection and retry.');
        setOpenErrorComponent(true);
        setLoadingStatus(false);
        setLoadingStatusMessage([]);
    }
};
exports.fetchChatStream = __webpack_exports__.fetchChatStream;
exports.submitChatMessages = __webpack_exports__.submitChatMessages;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "fetchChatStream",
    "submitChatMessages"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
